/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface AdminDataWorkAgencyGrantIdDTO
 */
export interface AdminDataWorkAgencyGrantIdDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkAgencyGrantIdDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkAgencyGrantIdDTO
     */
    grantId?: string;
}

/**
 * Check if a given object implements the AdminDataWorkAgencyGrantIdDTO interface.
 */
export function instanceOfAdminDataWorkAgencyGrantIdDTO(value: object): value is AdminDataWorkAgencyGrantIdDTO {
    return true;
}

export function AdminDataWorkAgencyGrantIdDTOFromJSON(json: any): AdminDataWorkAgencyGrantIdDTO {
    return AdminDataWorkAgencyGrantIdDTOFromJSONTyped(json, false);
}

export function AdminDataWorkAgencyGrantIdDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkAgencyGrantIdDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'grantId': json['grantId'] == null ? undefined : json['grantId'],
    };
}

export function AdminDataWorkAgencyGrantIdDTOToJSON(json: any): AdminDataWorkAgencyGrantIdDTO {
    return AdminDataWorkAgencyGrantIdDTOToJSONTyped(json, false);
}

export function AdminDataWorkAgencyGrantIdDTOToJSONTyped(value?: AdminDataWorkAgencyGrantIdDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'grantId': value['grantId'],
    };
}


